export default "__VITE_ASSET__ccdf2718__"